import {FormikHelpers} from 'formik';
import {cloneDeep} from 'utils';

type TFormValuesWithFile = {file?: unknown};

export const snapshotResourceFormValues = <T>(values: T): T => {
  const snapshot = cloneDeep(values) as T;
  const formValues = values as TFormValuesWithFile;
  if (formValues && typeof formValues === 'object' && 'file' in formValues) {
    (snapshot as TFormValuesWithFile).file = formValues.file;
  }
  return snapshot;
};

/**
 * Awaits the request and always ends submitting. Form restore/clear is owned
 * by the caller from a known success or error signal.
 */
export const runResourceFormSubmit = async <T>(
  _values: T,
  {setSubmitting}: FormikHelpers<T>,
  submit: () => Promise<unknown>
): Promise<void> => {
  try {
    await submit();
  } finally {
    setSubmitting(false);
  }
};
